/**
 * Mosteller body surface area in m².
 * BSA = √((height_cm × weight_kg) / 3600)
 */
export function calculateBsa(heightCm: number, weightKg: number): number {
  return Math.sqrt((heightCm * weightKg) / 3600);
}
